'use client'

import enMessages from '@next-app/messages/en'
import { NextIntlClientProvider } from 'next-intl'
import { ReactNode } from 'react'

/**
 * English default provider for routes outside a site context. Must be a client
 * component: rendering NextIntlClientProvider from a Server Component makes
 * next-intl look for a request-config file, which the CMS doesn't use (the
 * locale is resolved client-side per site in the [siteId] layout).
 */
export const EnglishIntlProvider = ({ children }: { children: ReactNode }) => (
  <NextIntlClientProvider locale="en" messages={enMessages}>
    {children}
  </NextIntlClientProvider>
)
